// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yMQX","comment":"styles_comment__2yfLh"};